import Vue from 'vue'
import Vuex from 'vuex'

import main from './main'
import admin from './admin'
import contacts from './contacts'
import projects from './projects'
import vendors from './vendors'
import taskTemplates from './taskTemplates'
import tasks from './tasks'
import notes from './notes'
import dropdowns from './dropdowns'
import helpers from './helpers'
import reports from './reports'
import leads from './leads'
import global from './global'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    main,
    admin,
    contacts,
    projects,
    vendors,
    taskTemplates,
    tasks,
    notes,
    dropdowns,
    helpers,
    reports,
    leads,
    global
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js